import { Component, Input, OnInit } from '@angular/core';
import { GalleryImageService } from '../../../services/gallery-image.service';
import { ChatAttachments, ChatMessage } from '../../../services/chat-http.service';

@Component({
  selector: 'app-chat-message-system',
  templateUrl: './chat-message-system.component.html',
  styleUrls: ['./chat-message-system.component.scss']
})
export class ChatMessageSystemComponent {
  @Input() data: ChatMessage;
}
